export default __webpack_public_path__ + "e9ca192bee5fbbf13069ca7b511e28a6.png";